import Contact from '@models/Contact';
import { Map } from 'immutable';
import type { ID, ReduxAction } from '../../types';
import { ActivityViewState } from '@views/Activity';
import Note from '@models/Note';

// This is a generic view state for saving a single selected contact state, e.g. in People view
type PersonListViewState = { selectedContact: Contact | null };
type NotesListViewState = { highlightedNote: Note | null };
export type MapViewState = {
  selectedContactID: ID | null;
  selectedClusterID: number | null;
  selectedClusterContactIDs: ID[];
  selectedClusterSelectedContactID: ID | null;
  visibleMapRect: mapkit.MapRect | null;
};
type RestorableViewID =
  | 'People'
  | 'Activity'
  | 'Notes'
  | `Group_${ID}`
  | `GroupActivity_${ID}`
  | 'Map';
export type ViewID = RestorableViewID | 'Archive';
export type AnyViewState = Partial<
  PersonListViewState & ActivityViewState & NotesListViewState & MapViewState
>;
export type ViewRestorationState = Map<ViewID, AnyViewState>;

const defaultViewRestorationState = Map<RestorableViewID, AnyViewState>({
  Activity: null,
  People: null,
});

export function viewRestorationReducer(
  state: ViewRestorationState = defaultViewRestorationState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SAVE_VIEW_STATE':
      return state.set(payload.viewID, payload.state);

    default:
      return state;
  }
}
